import React, { Component } from 'react';
import * as UiConsts from '../../../../config/UiConstants';
import {  Button, } from 'semantic-ui-react';
import {  pythonApiIp, } from '../../../../config/constants.js'
import axios from 'axios'

class PayItemGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    makePayment = () => {
        console.log("++++++++:makePayment");
        console.log("item:" + JSON.stringify(this.props.item, null, 3));
        this.setState({ loading: true });

        axios.post(pythonApiIp + 'payAllOfAnItem', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: this.props.user.email,
            item: this.props.item.itemCode
        })
            .then((response) => {
                this.setState({ loading: false });
                console.log(JSON.stringify(response.data, null, 3));

                if (response.data.result) {
        
                    this.setState({
                        loading: false,
                    });

                    alert(response.data.message);
                    this.props.getUnpaidList();

                } else {
                    this.setState({ loading: false });
                    alert(response.data.message);
                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }


    render() { 
        return ( this.state.loading ? <UiConsts.LoadingComponent /> :<div>
            <Button onClick={this.makePayment}> Pay {this.props.item.itemCode}</Button>
        </div> );
    }
}
 
export default PayItemGroup;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/PayItemGroup.js